<div *ngFor="let option of options; index as i" class="form-check">
    <input type="checkbox" class="form-check-input" [id]="category + '-' + i"
        [checked]="checkedValues[option.value]" [disabled]="disabled"
        (change)="onToggle(option, $event.target.checked)">
    <label class="form-check-label" [for]="category + '-' + i">{{ option.value }}</label>
    <input *ngIf="option.is_free_text && checkedValues[option.value]" type="text"
        class="form-control mt-1" placeholder="Précisez" [ngModel]="freeText"
        [ngModelOptions]="{standalone: true}" [disabled]="disabled"
        (ngModelChange)="onFreeTextChange($event)">
</div>
